import { Button, Head, Link } from "zudoku/components"

export const NotFound = () => {
  return (
    <section className="flex items-center justify-center py-20">
      <Head>
        <title>Not Found - 404</title>
      </Head>
      <div className="text-center max-w-lg mx-auto">
        <p className="text-6xl font-extrabold text-primary mb-4">404</p>
        <h1 className="text-3xl font-bold mb-4">Not Found</h1>
        <p className="text-muted-foreground mb-8">
          It appears that this API documentation link is either invalid or no longer
          available.
        </p>
        <div className="flex gap-4 justify-center">
          <Button asChild>
            <Link to="/">Go to Public API</Link>
          </Button>
          <Button variant="secondary" asChild>
            <Link to="/catalog">Browse API Catalog</Link>
          </Button>
        </div>
      </div>
    </section>
  )
}
